import React from 'react'
import { VerificationsList } from './list/page'

export const VerificationPage = (): JSX.Element => {
  return <VerificationsList/>
}
